const dsar_messages = {
  cases: {
    page_title: ['dsar>>cases>>page_title', 'DSAR cases'],
    create_button: ['dsar>>cases>>create_button', 'New DSAR case'],
    create_dialog: {
      title: ['dsar>>cases>>create_dialog>>title', 'New DSAR case'],
      intro: [
        'dsar>>cases>>create_dialog>>intro',
        'Create the case details first. When the case is ready, it can be sent to affected asset owners.',
      ],
      requester_section: ['dsar>>cases>>create_dialog>>requester_section', 'Requester'],
      case_section: ['dsar>>cases>>create_dialog>>case_section', 'Case details'],
      requester_name: ['dsar>>cases>>create_dialog>>requester_name', 'Requester name'],
      requester_email: ['dsar>>cases>>create_dialog>>requester_email', 'Requester email'],
      requester_phone: ['dsar>>cases>>create_dialog>>requester_phone', 'Phone'],
      requester_customernumber: ['dsar>>cases>>create_dialog>>requester_customernumber', 'Customer number'],
      requester_ssn: ['dsar>>cases>>create_dialog>>requester_ssn', 'Personal identity number'],
      requester_address_line1: ['dsar>>cases>>create_dialog>>requester_address_line1', 'Address line 1'],
      requester_address_line2: ['dsar>>cases>>create_dialog>>requester_address_line2', 'Address line 2'],
      requester_postalcode: ['dsar>>cases>>create_dialog>>requester_postalcode', 'Postal code'],
      requester_city: ['dsar>>cases>>create_dialog>>requester_city', 'City'],
      requester_country: ['dsar>>cases>>create_dialog>>requester_country', 'Country'],
      identity_verification_status: ['dsar>>cases>>create_dialog>>identity_verification_status', 'Identity verification'],
      identity_verification_notes: ['dsar>>cases>>create_dialog>>identity_verification_notes', 'Identity verification notes'],
      status: ['dsar>>cases>>create_dialog>>status', 'Case status'],
      received_at: ['dsar>>cases>>create_dialog>>received_at', 'Received date'],
      due_date: ['dsar>>cases>>create_dialog>>due_date', 'Due date'],
      request_types: ['dsar>>cases>>create_dialog>>request_types', 'Request types'],
      admin_instruction_comment: ['dsar>>cases>>create_dialog>>admin_instruction_comment', 'Internal instructions'],
      instruction_link: ['dsar>>cases>>create_dialog>>instruction_link', 'Instruction link'],
      portability_instruction: ['dsar>>cases>>create_dialog>>portability_instruction', 'Portability instructions'],
      portability_output_link: ['dsar>>cases>>create_dialog>>portability_output_link', 'Output file area link'],
      domain_values_loading: ['dsar>>cases>>create_dialog>>domain_values_loading', 'Loading DSAR choices...'],
    },
    edit_dialog: {
      title: ['dsar>>cases>>edit_dialog>>title', 'Edit DSAR case'],
      intro: [
        'dsar>>cases>>edit_dialog>>intro',
        'Update the case details. Identity verification and request types are locked after the case has been sent to asset owners.',
      ],
    },
    help: {
      title: ['dsar>>cases>>help>>title', 'How DSAR cases work'],
      body: [
        'dsar>>cases>>help>>body',
        '<p>DSAR cases are prepared by a DSAR administrator before they are sent to affected asset owners.</p><ul><li>Create the case and select the request types.</li><li>Send the case to create asset-owner tasks for relevant GDPR assets.</li><li>Track status, identity verification, deadlines and responses from this page.</li></ul>',
      ],
    },
    table: {
      aria_label: ['dsar>>cases>>table>>aria_label', 'DSAR cases table'],
      case_reference: ['dsar>>cases>>table>>case_reference', 'Case reference'],
      requester: ['dsar>>cases>>table>>requester', 'Requester'],
      request_types: ['dsar>>cases>>table>>request_types', 'Request types'],
      status: ['dsar>>cases>>table>>status', 'Status'],
      overdue: ['dsar>>cases>>table>>overdue', 'Overdue'],
      identity_verification: ['dsar>>cases>>table>>identity_verification', 'Identity verification'],
      received_at: ['dsar>>cases>>table>>received_at', 'Received'],
      due_date: ['dsar>>cases>>table>>due_date', 'Due date'],
      distributed: ['dsar>>cases>>table>>distributed', 'Distributed'],
      created_at: ['dsar>>cases>>table>>created_at', 'Created'],
      actions: ['dsar>>cases>>table>>actions', 'Actions'],
    },
    filters: {
      status: ['dsar>>cases>>filters>>status', 'Status'],
      request_types: ['dsar>>cases>>filters>>request_types', 'Request types'],
      identity_verification: ['dsar>>cases>>filters>>identity_verification', 'Identity verification'],
      past_due_date: ['dsar>>cases>>filters>>past_due_date', 'Past due date'],
      past_due_date_option: ['dsar>>cases>>filters>>past_due_date_option', 'Overdue cases'],
    },
    actions: {
      open: ['dsar>>cases>>actions>>open', 'Open'],
      edit: ['dsar>>cases>>actions>>edit', 'Edit'],
      delete: ['dsar>>cases>>actions>>delete', 'Delete'],
      open_asset_cases: ['dsar>>cases>>actions>>open_asset_cases', 'Open asset cases'],
      send_to_asset_owners: ['dsar>>cases>>actions>>send_to_asset_owners', 'Send to asset owners'],
    },
    delete_confirmation: {
      title: ['dsar>>cases>>delete_confirmation>>title', 'Delete DSAR case'],
      body: [
        'dsar>>cases>>delete_confirmation>>body',
        'Are you sure you want to delete {{caseReference}}? This can only be done before the case has been sent to asset owners.',
      ],
    },
    detail: {
      title: ['dsar>>cases>>detail>>title', 'DSAR case'],
      tab_case_details: ['dsar>>cases>>detail>>tab_case_details', 'Case details'],
      tab_asset_handling: ['dsar>>cases>>detail>>tab_asset_handling', 'Asset handling'],
      tab_close_case: ['dsar>>cases>>detail>>tab_close_case', 'Close case'],
      section_requester: ['dsar>>cases>>detail>>section_requester', 'Requester details'],
      section_case: ['dsar>>cases>>detail>>section_case', 'Case details'],
      section_identity_verification: ['dsar>>cases>>detail>>section_identity_verification', 'Identity verification'],
      section_asset_owner_instructions: ['dsar>>cases>>detail>>section_asset_owner_instructions', 'Instruction to asset owners'],
      section_asset_handling: ['dsar>>cases>>detail>>section_asset_handling', 'Asset handling'],
      section_asset_handling_intro: [
        'dsar>>cases>>detail>>section_asset_handling_intro',
        'Review each affected system, its owner, current handling status, and the request-type level results before closing the case.',
      ],
      section_close_summary: ['dsar>>cases>>detail>>section_close_summary', 'Request type summary'],
      section_response_log: ['dsar>>cases>>detail>>section_response_log', 'Response log'],
      section_retention: ['dsar>>cases>>detail>>section_retention', 'Anonymization and retention'],
      response_log_helper: [
        'dsar>>cases>>detail>>response_log_helper',
        'Add each outgoing response or notice here. Comments in this log will be anonymized later according to the retention rule.',
      ],
      communication_type: ['dsar>>cases>>detail>>communication_type', 'Communication type'],
      communication_comment: ['dsar>>cases>>detail>>communication_comment', 'Comment'],
      add_response_log: ['dsar>>cases>>detail>>add_response_log', 'Add response log'],
      no_response_logs: ['dsar>>cases>>detail>>no_response_logs', 'No response has been logged yet.'],
      communication_type_response: ['dsar>>cases>>detail>>communication_type_response', 'Response'],
      communication_type_extension_notice: ['dsar>>cases>>detail>>communication_type_extension_notice', 'Extension Notice'],
      communication_type_identity_verification_request: [
        'dsar>>cases>>detail>>communication_type_identity_verification_request',
        'Identity Verification Request',
      ],
      communication_type_identity_verification_approved: [
        'dsar>>cases>>detail>>communication_type_identity_verification_approved',
        'Identity Verification Approved',
      ],
      communication_type_additional_information_request: [
        'dsar>>cases>>detail>>communication_type_additional_information_request',
        'Additional Information Request',
      ],
      communication_type_partial_response: ['dsar>>cases>>detail>>communication_type_partial_response', 'Partial Response'],
      communication_type_final_response: ['dsar>>cases>>detail>>communication_type_final_response', 'Final Response'],
      communication_type_other: ['dsar>>cases>>detail>>communication_type_other', 'Other'],
      sent_at: ['dsar>>cases>>detail>>sent_at', 'Sent at'],
      sent_by_user: ['dsar>>cases>>detail>>sent_by_user', 'Sent by'],
      days_since_received: ['dsar>>cases>>detail>>days_since_received', 'Days since received'],
      retention_helper: [
        'dsar>>cases>>detail>>retention_helper',
        'When the case is closed, the retention timer starts from the closed date. After retention, requester fields and DSAR free-text fields are anonymized.',
      ],
      retention_anonymization_notice: [
        'dsar>>cases>>detail>>retention_anonymization_notice',
        'This case is scheduled for anonymization on {{date}}.',
      ],
      retention_anonymized_notice: ['dsar>>cases>>detail>>retention_anonymized_notice', 'This case was anonymized on {{date}}.'],
      retention_pending_notice: [
        'dsar>>cases>>detail>>retention_pending_notice',
        'The anonymization date will be set when the case is closed.',
      ],
      not_anonymized_yet: ['dsar>>cases>>detail>>not_anonymized_yet', 'Not yet anonymized'],
      close_case_ready_helper: [
        'dsar>>cases>>detail>>close_case_ready_helper',
        'Mark the case as completed after at least one response has been logged and the handling work is ready to close.',
      ],
      close_case_confirmation_title: ['dsar>>cases>>detail>>close_case_confirmation_title', 'Close DSAR case'],
      close_case_confirmation_body: [
        'dsar>>cases>>detail>>close_case_confirmation_body',
        'Are you sure you want to close {{caseReference}}? This sets the closed date and starts the retention timer.',
      ],
      close_case_success: ['dsar>>cases>>detail>>close_case_success', 'The DSAR case was closed and the retention timer has started.'],
      request_type_summary_completed_assets: ['dsar>>cases>>detail>>request_type_summary_completed_assets', 'Completed assets'],
      request_type_summary_not_completed_assets: ['dsar>>cases>>detail>>request_type_summary_not_completed_assets', 'Not completed assets'],
      request_type_summary_blocking_assets: ['dsar>>cases>>detail>>request_type_summary_blocking_assets', 'Blocking assets'],
      request_type_summary_latest_planned_date: [
        'dsar>>cases>>detail>>request_type_summary_latest_planned_date',
        'Latest planned completion date',
      ],
      show_summary_details: ['dsar>>cases>>detail>>show_summary_details', 'Show details ({{count}})'],
      hide_summary_details: ['dsar>>cases>>detail>>hide_summary_details', 'Hide details'],
      summary_blocking_details: ['dsar>>cases>>detail>>summary_blocking_details', 'Blocked assets'],
      summary_pending_details: ['dsar>>cases>>detail>>summary_pending_details', 'Pending assets'],
      summary_detail_asset: ['dsar>>cases>>detail>>summary_detail_asset', 'Asset'],
      summary_detail_owner: ['dsar>>cases>>detail>>summary_detail_owner', 'Owner'],
      summary_detail_status: ['dsar>>cases>>detail>>summary_detail_status', 'Status'],
      summary_detail_reason: ['dsar>>cases>>detail>>summary_detail_reason', 'Blocking reason'],
      summary_detail_planned_date: ['dsar>>cases>>detail>>summary_detail_planned_date', 'Planned date'],
      summary_pending_hidden: [
        'dsar>>cases>>detail>>summary_pending_hidden',
        '{{count}} more pending assets are listed in Asset handling.',
      ],
      no_blocking_assets: ['dsar>>cases>>detail>>no_blocking_assets', 'None'],
      closed_at: ['dsar>>cases>>detail>>closed_at', 'Closed at'],
      closed_by_user: ['dsar>>cases>>detail>>closed_by_user', 'Closed by'],
      retention_until: ['dsar>>cases>>detail>>retention_until', 'Retention until'],
      response_summary: ['dsar>>cases>>detail>>response_summary', 'Response summary'],
      response_sent_at: ['dsar>>cases>>detail>>response_sent_at', 'Response sent at'],
      response_sent_by_user: ['dsar>>cases>>detail>>response_sent_by_user', 'Response sent by'],
      identifiers_anonymized_at: ['dsar>>cases>>detail>>identifiers_anonymized_at', 'Identifiers anonymized at'],
      mark_as_completed: ['dsar>>cases>>detail>>mark_as_completed', 'Mark as completed'],
      distributed_banner: [
        'dsar>>cases>>detail>>distributed_banner',
        'This case has been sent to asset owners. Identity verification and request types are now locked.',
      ],
      identity_verification_required: [
        'dsar>>cases>>detail>>identity_verification_required',
        'The case can only be sent when identity verification status is Verified and identity verification notes are filled in.',
      ],
      send_summary: [
        'dsar>>cases>>detail>>send_summary',
        'Sending the case creates or reuses asset-owner tasks for relevant GDPR assets in your organization.',
      ],
      send_assets_dialog_title: ['dsar>>cases>>detail>>send_assets_dialog_title', 'Send DSAR case to asset owners'],
      send_assets_dialog_intro: [
        'dsar>>cases>>detail>>send_assets_dialog_intro',
        'Select the assets that should receive DSAR asset cases. Only assets with personal data metadata are shown.',
      ],
      send_assets_select_all: ['dsar>>cases>>detail>>send_assets_select_all', 'Select all'],
      send_assets_clear_all: ['dsar>>cases>>detail>>send_assets_clear_all', 'Clear all'],
      send_assets_selected_count: ['dsar>>cases>>detail>>send_assets_selected_count', '{{count}} selected'],
      send_assets_required: ['dsar>>cases>>detail>>send_assets_required', 'Select at least one asset before sending the case.'],
      send_assets_empty: ['dsar>>cases>>detail>>send_assets_empty', 'No assets with personal data metadata were found.'],
      send_assets_asset_name: ['dsar>>cases>>detail>>send_assets_asset_name', 'Asset name'],
      send_assets_owner: ['dsar>>cases>>detail>>send_assets_owner', 'Owner'],
      send_assets_asset_type: ['dsar>>cases>>detail>>send_assets_asset_type', 'Asset type'],
      send_assets_personal_data: ['dsar>>cases>>detail>>send_assets_personal_data', 'Personal data'],
      send_assets_sensitive_personal_data: ['dsar>>cases>>detail>>send_assets_sensitive_personal_data', 'Sensitive personal data'],
      send_assets_submit: ['dsar>>cases>>detail>>send_assets_submit', 'Send case'],
      distribution_result: [
        'dsar>>cases>>detail>>distribution_result',
        'The case was sent. {{assetsCreated}} new asset tasks were created and {{requestTypesCreated}} request type tasks were added.',
      ],
    },
    empty_state: {
      title: ['dsar>>cases>>empty_state>>title', 'No DSAR cases found'],
      description: ['dsar>>cases>>empty_state>>description', 'No cases match the current search.'],
    },
  },
  case_assets: {
    page_title: ['dsar>>case_assets>>page_title', 'DSAR asset cases'],
    page_description: [
      'dsar>>case_assets>>page_description',
      'Track DSAR work per asset. DSAR administrators see all tenant cases, while asset owners only see their own assets.',
    ],
    help: {
      title: ['dsar>>case_assets>>help>>title', 'How DSAR asset cases work'],
      body: [
        'dsar>>case_assets>>help>>body',
        '<p>Each DSAR asset case represents the work for one relevant asset in a DSAR case.</p><ul><li>Use filters to focus on specific statuses, data findings, or request types.</li><li>Open a row to review the asset owner response and request type results.</li><li>DSAR administrators can follow all cases in the organization, while asset owners only see their own asset cases.</li></ul>',
      ],
    },
    table: {
      aria_label: ['dsar>>case_assets>>table>>aria_label', 'DSAR asset cases table'],
      case_reference: ['dsar>>case_assets>>table>>case_reference', 'Case reference'],
      asset_name: ['dsar>>case_assets>>table>>asset_name', 'Asset'],
      owner: ['dsar>>case_assets>>table>>owner', 'Owner'],
      request_types: ['dsar>>case_assets>>table>>request_types', 'Request types'],
      due_date: ['dsar>>case_assets>>table>>due_date', 'Due date'],
      status: ['dsar>>case_assets>>table>>status', 'Status'],
      data_found: ['dsar>>case_assets>>table>>data_found', 'Data found'],
      completed_at: ['dsar>>case_assets>>table>>completed_at', 'Completed'],
      actions: ['dsar>>case_assets>>table>>actions', 'Actions'],
    },
    actions: {
      open: ['dsar>>case_assets>>actions>>open', 'Open'],
      edit: ['dsar>>case_assets>>actions>>edit', 'Edit'],
      reopen: ['dsar>>case_assets>>actions>>reopen', 'Reopen'],
      open_case: ['dsar>>case_assets>>actions>>open_case', 'Open DSAR case'],
      cancel_editing: ['dsar>>case_assets>>actions>>cancel_editing', 'Cancel editing'],
      add_status_log: ['dsar>>case_assets>>actions>>add_status_log', 'Add log row'],
      save_summary: ['dsar>>case_assets>>actions>>save_summary', 'Save asset summary'],
      save_request_type: ['dsar>>case_assets>>actions>>save_request_type', 'Save request type'],
      complete_asset_case: ['dsar>>case_assets>>actions>>complete_asset_case', 'Complete asset case'],
    },
    filters: {
      status: ['dsar>>case_assets>>filters>>status', 'Status'],
      data_found: ['dsar>>case_assets>>filters>>data_found', 'Data found'],
      request_types: ['dsar>>case_assets>>filters>>request_types', 'Request types'],
    },
    validation: {
      result_summary_required_after_start: [
        'dsar>>case_assets>>validation>>result_summary_required_after_start',
        'Result summary is required when work has started.',
      ],
      result_summary_required_for_final: [
        'dsar>>case_assets>>validation>>result_summary_required_for_final',
        'Result summary is required when handling reaches a final state.',
      ],
      blocking_reason_required_for_blocked: [
        'dsar>>case_assets>>validation>>blocking_reason_required_for_blocked',
        'Blocking reason is required for deferred or not possible handling.',
      ],
      blocking_reason_only_for_blocked: [
        'dsar>>case_assets>>validation>>blocking_reason_only_for_blocked',
        'Blocking reason must be empty unless handling is deferred or not possible.',
      ],
      earliest_date_required_for_deferred: [
        'dsar>>case_assets>>validation>>earliest_date_required_for_deferred',
        'Earliest possible action date is required for deferred handling.',
      ],
      earliest_date_only_for_deferred: [
        'dsar>>case_assets>>validation>>earliest_date_only_for_deferred',
        'Earliest possible action date must be empty unless handling is deferred.',
      ],
      asset_owner_comment_required_for_completed: [
        'dsar>>case_assets>>validation>>asset_owner_comment_required_for_completed',
        'Asset owner comment is required when the asset case is completed.',
      ],
      data_found_required_for_completion: [
        'dsar>>case_assets>>validation>>data_found_required_for_completion',
        'Data found must be selected before the asset case can be completed.',
      ],
      result_summary_required_for_completion: [
        'dsar>>case_assets>>validation>>result_summary_required_for_completion',
        'Result summary is required before the asset case can be completed.',
      ],
      request_types_must_be_final_for_completion: [
        'dsar>>case_assets>>validation>>request_types_must_be_final_for_completion',
        'All request type rows must be in a final state before completion.',
      ],
      completed_status_missing: [
        'dsar>>case_assets>>validation>>completed_status_missing',
        'Completed status is not configured for DSAR asset cases.',
      ],
      status_required_for_log: ['dsar>>case_assets>>validation>>status_required_for_log', 'Status is required for the log row.'],
      comment_required_for_log: ['dsar>>case_assets>>validation>>comment_required_for_log', 'Comment is required for the log row.'],
    },
    guidance: {
      not_started: [
        'dsar>>case_assets>>guidance>>not_started',
        'Not started does not require a summary, blocking reason, or planned date yet.',
      ],
      started: ['dsar>>case_assets>>guidance>>started', 'This status requires a result summary describing the current handling.'],
      deferred: [
        'dsar>>case_assets>>guidance>>deferred',
        'Deferred requires a result summary, a blocking reason, and the earliest possible action date.',
      ],
      not_possible: [
        'dsar>>case_assets>>guidance>>not_possible',
        'Not possible requires a result summary and a blocking reason. Do not set a planned date.',
      ],
    },
    empty_state: {
      title: ['dsar>>case_assets>>empty_state>>title', 'No DSAR asset cases found'],
      description: ['dsar>>case_assets>>empty_state>>description', 'No asset cases match the current search.'],
    },
    detail: {
      title: ['dsar>>case_assets>>detail>>title', 'DSAR asset case'],
      case_context: ['dsar>>case_assets>>detail>>case_context', 'Case context'],
      case_context_intro: [
        'dsar>>case_assets>>detail>>case_context_intro',
        'Review the parent DSAR case details and internal instructions before updating this asset case.',
      ],
      data_subject_section: ['dsar>>case_assets>>detail>>data_subject_section', 'Data subject details'],
      personal_data_warning_title: ['dsar>>case_assets>>detail>>personal_data_warning_title', 'Sensitive personal data'],
      personal_data_warning_body: [
        'dsar>>case_assets>>detail>>personal_data_warning_body',
        'These personal details are shown only to help complete the DSAR case. Do not save, spread, or reuse them beyond what is strictly necessary to handle the case.',
      ],
      request_work_section: ['dsar>>case_assets>>detail>>request_work_section', 'Customer request handling'],
      request_work_intro: [
        'dsar>>case_assets>>detail>>request_work_intro',
        'Handle each request for this person, report the current status, and provide a clear summary. If a request cannot be completed in full, explain why and document how the work should be planned so it can be completed when possible.',
      ],
      request_types: ['dsar>>case_assets>>detail>>request_types', 'Request type results'],
      asset_section: ['dsar>>case_assets>>detail>>asset_section', 'Asset details'],
      summary_section: ['dsar>>case_assets>>detail>>summary_section', 'Handling summary'],
      case_details_section: ['dsar>>case_assets>>detail>>case_details_section', 'Case details'],
      result_summary: ['dsar>>case_assets>>detail>>result_summary', 'Result summary'],
      status_log: ['dsar>>case_assets>>detail>>status_log', 'Status and result log'],
      status_log_comment: ['dsar>>case_assets>>detail>>status_log_comment', 'Comment'],
      status_log_empty: ['dsar>>case_assets>>detail>>status_log_empty', 'No status log rows yet.'],
      asset_owner_comment: ['dsar>>case_assets>>detail>>asset_owner_comment', 'Asset owner comment'],
      blocking_reason: ['dsar>>case_assets>>detail>>blocking_reason', 'Blocking reason'],
      earliest_possible_action_date: ['dsar>>case_assets>>detail>>earliest_possible_action_date', 'Earliest possible action date'],
      manual_review_required: ['dsar>>case_assets>>detail>>manual_review_required', 'Manual review required'],
      third_party_data_risk: ['dsar>>case_assets>>detail>>third_party_data_risk', 'Third-party data risk'],
      distributed_banner: [
        'dsar>>case_assets>>detail>>distributed_banner',
        'This asset case is active. Use edit mode to document findings per asset and request type.',
      ],
      completed_banner: ['dsar>>case_assets>>detail>>completed_banner', 'This asset case is completed. Reopen it if more work is needed.'],
    },
    completion: {
      title: ['dsar>>case_assets>>completion>>title', 'Complete asset case'],
      intro: [
        'dsar>>case_assets>>completion>>intro',
        'Complete the asset case when the request type work is final and the asset-level handling summary is ready.',
      ],
      request_types_ready: ['dsar>>case_assets>>completion>>request_types_ready', 'All request type rows are in a final state.'],
      request_types_not_ready: [
        'dsar>>case_assets>>completion>>request_types_not_ready',
        'These request type rows must be finalized first:',
      ],
    },
  },
};

export default dsar_messages;
